"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appletAllListApi = appletAllListApi;
exports.appletCreateApi = appletCreateApi;
exports.appletDeleteApi = appletDeleteApi;
exports.appletDetailApi = appletDetailApi;
exports.appletListApi = appletListApi;
exports.appletUpdateApi = appletUpdateApi;
exports.appletUpdateStatusApi = appletUpdateStatusApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 应用列表
 * @param params
 */
function appletListApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/application/list',
    method: 'GET',
    params: params
  });
}

/**
 * 新增应用
 * @param data
 */
function appletCreateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/application/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑应用
 * @param data
 */
function appletUpdateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/application/save',
    method: 'POST',
    data: data
  });
}

/**
 * 删除应用
 */
function appletDeleteApi(id) {
  return (0, _request.default)({
    url: "admin/platform/application/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 应用详情
 * @param id
 */
function appletDetailApi(id) {
  return (0, _request.default)({
    url: "admin/platform/application/detail/".concat(id),
    method: 'GET'
  });
}

/**
 * 设置应用状态
 * @param data
 */
function appletUpdateStatusApi(data) {
  return (0, _request.default)({
    url: "admin/platform/application/updateStatus/".concat(data.id),
    method: 'POST',
    data: data
  });
}

/**
 * 获取全部应用列表
 */
function appletAllListApi() {
  return (0, _request.default)({
    url: "admin/platform/application/enabledList",
    method: 'GET'
  });
}